import Step from "@frog/source/models/Step.js"
import Zone from "@frog/source/models/Zone.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import RollModal from "@frog/source/data/games/dice/views/RollModal.jsx"

export function RollPomp() {
    return [
        ClearRolls(),

        Step.deltastage({
            "player": {
                "phase": "rolling",
                "zoomout": 0.75,
                "rollcount": 3
            },
        }),
        PlotSteps.Wait(800),

        PlotSteps.PlayAudio("Dice:Roll"),
        Roll({"affiliations": ["bad"]}),
        PlotSteps.Wait(1600),
        function(stage) {
            const step = {"deltastages": []}
            Object.values(stage.units).forEach((unit) => {
                if(unit.affiliation == "bad") {
                    step.deltastages.push({
                        "unit": {
                            "key": unit.key,
                            "isLockedIn": true,
                        }
                    })
                }
            })
            return step
        },
        PlotSteps.Wait(1200),

        (stage) => {
            if(window.hasRolled != true) {
                return RollModal()
            }
        },

        PlotSteps.PlayAudio("Dice:Roll"),
        Roll({"affiliations": ["good"]}),

        PlotSteps.PlayStinger("Stinger:PlayerTurn"),
        Step.deltastage({
            "player": {
                "phase": "rolling",
                "rollcount": 2
            },
        }),
        // PlotSteps.Wait(1200),
    ]
}

export function Roll({affiliations}) {
    return function(stage) {
        const step = {"deltastages": []}
        affiliations = affiliations ?? ["good", "bad"]

        affiliations.forEach((affiliation) => {
            const units = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.isLockedIn != true
                    && unit.affiliation == affiliation
                    && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
            })
            units.forEach((unit, index) => {
                if(unit.affiliation != affiliation) return
                if(unit.diceFaces == undefined) return
                const diceFace = stage.random.element(Object.values(unit.diceFaces))
                step.deltastages.push({
                    "unit": {
                        "key": unit.key,
                        "primaryItem": diceFace,
                        "equippedItem": diceFace,
                        "rollingIndex": index,
                    }
                })
            })
        })
        return step
    }
}

export function ClearRolls() {
    return function(stage) {
        const deltastages = []
        Object.values(stage.units).forEach((unit) => {
            deltastages.push({
                "unit": {
                    "key": unit.key,
                    "primaryItem": null,
                    "equippedItem": null,
                    "power": 0,
                    // "moverange": 2, // TODO: make this a temp effect, not the actual stat. THIS IS BREAKING THE SLIMES
                    "moverange": unit.jobKey != undefined && unit.jobKey.includes("slime") ? 1 : 2,
                    "armor": 0,
                }
            })
        })
        return {
            "deltastages": deltastages
        }
    }
}
